import React from 'react';
import { useParams } from 'react-router-dom';

import { usePermissions } from '@/shared/features/ability/hooks/use-permissions/use-permissions';
import { NoPermission } from '@/shared/features/error/components/no-permission/no-permission';
import { useOwnUserRoles } from '@/shared/features/rbac/hooks/use-own-user-roles/use-own-user-roles';
import { useTypedMatches } from '@/shared/hooks/use-typed-matches/use-typed-matches';

export const PermissionRoute = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const matches = useTypedMatches();
  const { userRoleId } = useParams();
  const { isLoggedInUserRole } = useOwnUserRoles();
  const match = matches.find((match) => Boolean(match.handle));
  const entity = match?.handle?.entity;
  const action = match?.handle?.action;
  const hasPermission = usePermissions({ action: action ?? 'read', entity });

  // A user may always read a role they belong to, even without the policy.
  const isOwnRoleRead =
    entity === 'Ident' &&
    action === 'readUserRole' &&
    isLoggedInUserRole(userRoleId);

  if (!hasPermission && !isOwnRoleRead) {
    return <NoPermission />;
  }

  return children;
};
